import { registerDecorator, ValidationOptions } from 'class-validator';

import { AllowedFsgmLocaleTypes, FsgmLocaleType } from '../';

/**
 * Checks if the value is an locale
 *
 */
export const IsCustomLocale = (validationOptions?: ValidationOptions) => {
  return (locale: object, propertyName: string) => {
    registerDecorator({
      name: 'IsCustomLocale',
      target: locale.constructor,
      propertyName: propertyName,
      constraints: [],
      options: {
        message: 'Not a valid locale',
        ...validationOptions,
      },
      validator: {
        validate(value: unknown) {
          return (
            typeof value === 'string' &&
            AllowedFsgmLocaleTypes.includes(value as FsgmLocaleType)
          );
        },
      },
    });
  };
};
